module.exports = __webpack_public_path__ + "static/media/CheckMark.9ef0323e.svg";